<script>
    import { setContext } from 'svelte'
    import { writable } from 'svelte/store'

    import Menu from './Menu.svelte'

    import { Container } from '@/components'

    import { scrollToAchor } from '@/helpers'

    const isOpen = writable(false)

    const toggleOpen = () => {
        $isOpen = !$isOpen
    }

    const handleSelect = (itemId) => {
        scrollToAchor(itemId, isOpen)
    }

    const items = [
        { id: 'game', title: 'Игра' },
        { id: 'func', title: 'Функционал' },
        { id: 'how-to', title: 'Как внедрить' },
        { id: 'prices', title: 'Стоимость' },
        { id: 'contacts', title: 'Контакты' },
    ]

    setContext('menu', {
        items,
        isOpen,
        toggleOpen,
        handleSelect
    })

</script>

<Container style="box-shadow: 0px 5px 12px 10px rgba(0, 0, 0, 0.03); position: fixed; top: 0; left: 0; z-index: 100; background: #ffffff;">
    <div class="wrapper">
        <img class="logo" src="./img/ucms-logo.png" alt="ucms logo" />

        <div class="menu-wrapper">
            <Menu {items} />
        </div>
    </div>

    
</Container>

{#if $isOpen}
    <div class="mobile-menu-wrapper">
        {#each items as item }
            <div on:click={() => handleSelect(item.id)}>{item.title}</div>
        {/each}
    </div>

    <div class="overlay" />
{/if}

<style module lang="scss">
    .wrapper {
        position: relative;
        display: flex;
        align-items: center;
        background:  #ffffff;
        height: 88px;
        
        .logo {
            width: auto;
            height: 30px;
        }

        .menu-wrapper {
            margin-left: auto;
        }
    }

    .mobile-menu-wrapper {
        position: fixed;
        top: 88px;
        left: 0;
        z-index: 100;
        width: 100%;
        background: #ffffff;
        padding-bottom: 44px;

        > div {
            padding: 20px 0;
            margin: 0 64px;
            border-bottom: 1px solid #EAEAEA;
            font-size: 18px;
            line-height: 23px;
            color: #282F3C;
            cursor: pointer;
        }
    }

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        background: #343B45;
        opacity: 0.6;
        width: 100%;
        height: 100%;
        z-index: 90;
    }
</style>

